import getNativeQuestions from './View/getNativeQuestions';
import { ATTRIBUTE_VALUE_LABELS, IDB_ATTRIBUTES, QUESTIONS, VIEW_LABEL } from './constants';

const idbView = {
  getNativeQuestions,
  pinnedFields: [
    IDB_ATTRIBUTES.DOCTOR,
    IDB_ATTRIBUTES.PRINT_ASSIGNMENT,
    IDB_ATTRIBUTES.INSERT_BRACKETS_ASSIGNMENT
  ],
  viewLabels: VIEW_LABEL,
  questions: QUESTIONS,
  attributeValueLabels: ATTRIBUTE_VALUE_LABELS,
  showTeeth: true
};

export default idbView;
